<template>
  <div class="position">
    <div class="position__top">
      <div class="position__title" v-text="page.title" />
      <div class="position__location" v-text="page.location" />
    </div>
    <article class="position__content">
      <div class="position__text" v-html="page.text" />
      <ul class="position__list">
        <li class="position__list-item" v-for="(item, i) in page.list"
          :key="i" v-text="item.item" />
      </ul>
      <div class="position__footer" v-html="page.footer" />
    </article>
  </div>
</template>

<script>
import page from '@/mixins/page'

export default {
  mixins: [page],
  name: 'PositionTemplate',
  data() {
    return {
      scrollTop: 0
    }
  },
  mounted() {
    var $page = document.querySelector('[data-page]')
    var $careerModal = document.querySelector('[data-career-modal]')
    $careerModal.style.top = $page.scrollTop + 'px'
    $page.style.zIndex = 5
    this.$store.dispatch('scrollFix')
  },
  destroyed() {
    this.$store.dispatch('scrollUnFix')
  }
}
</script>



// WEBPACK FOOTER //
// src/templates/PositionTemplate.vue